$(function(){
  $('a[href^="http:"],a[href^="https:"],a[rel^="external"]').attr('target','_blank');

  $('[data-confirm]').click(function(){
    return confirm($(this).attr('data-confirm'));
  });
});
